import '.bx{flex-shrink:0;}.ssr-plugin'
import '.by{padding:1rem;}.ssr-plugin'
import '.i{width:100%;}.ssr-plugin'
import '.bk{height:100%;}.ssr-plugin'
import '.bd{border:none;}.ssr-plugin'
import '.be{background-color:transparent;}.ssr-plugin'
import '.ey{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ad{align-items:stretch;}.ssr-plugin'
import '.d8{position:sticky;}.ssr-plugin'
import '.ez{top:4rem;}.ssr-plugin'
import '.f0{z-index:7;}.ssr-plugin'
import '.ag{background-color:var(--shades-white);}.ssr-plugin'
import '.f1{padding-bottom:1rem;}.ssr-plugin'
import '.a8{margin-bottom:1rem;}.ssr-plugin'
import '.f2{border-bottom:var(--blue-border);}.ssr-plugin'
import '.f{position:fixed;}.ssr-plugin'
import '.cn{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.f3{bottom:0px;}.ssr-plugin'
import '.dv{z-index:9999;}.ssr-plugin'
import '.f4{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.d2{justify-content:flex-end;}.ssr-plugin'
import '.bz{flex:1;}.ssr-plugin'
import '.ah{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bx by i bk bd be ey"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ad"
    >
      <div className="d8 ez f0 ag f1 a8 f2 a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="f cn bi bj f3 dv ag f4 a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="by a d2 f2"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bz ah">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
